// extracted by mini-css-extract-plugin
export default {"container":"About_container__WAkph","text":"About_text__W+Es2","title":"About_title__pWrV8"};